export default __webpack_public_path__ + "static/media/Foxtail-Lily_L1.10ec8118.png";